/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrgSettingsOutChannels } from './orgSettingsOutChannels';
import type { OrgSettingsOutDisclosures } from './orgSettingsOutDisclosures';
import type { OrgSettingsOutLimits } from './orgSettingsOutLimits';
import type { OrgSettingsOutListingDefaults } from './orgSettingsOutListingDefaults';
import type { OrgSettingsOutMediaPolicy } from './orgSettingsOutMediaPolicy';
import type { OrgSettingsOutModeRestrictions } from './orgSettingsOutModeRestrictions';
import type { OrgSettingsOutNotificationDefaults } from './orgSettingsOutNotificationDefaults';
import type { OrgSettingsOutRetention } from './orgSettingsOutRetention';

export interface OrgSettingsOut {
  org_id: string;
  consent_default: string;
  consent_collection?: string;
  disclosures: OrgSettingsOutDisclosures;
  grace_period_s: number;
  consent_reminder_min: number;
  notice_window_min: number;
  notice_lead_min: number;
  audio_prompt_policy: string;
  allow_interviewer_consent_override: boolean;
  own_domain_declines: boolean;
  chat_known_unavailable: boolean;
  retention: OrgSettingsOutRetention;
  media_policy: OrgSettingsOutMediaPolicy;
  export_transfer_allowed: boolean;
  channels: OrgSettingsOutChannels;
  participant_cap: number;
  join_lead_min: number;
  lobby_wait_min: number;
  member_wait_min: number;
  empty_room_wait_min: number;
  overrun_allowance_min: number;
  post_window_silence_min: number;
  max_session_h: number;
  panel_handoff_min: number;
  min_duration_s: number;
  notify_suppress_under_s: number;
  paused_reminder_min: number;
  default_adhoc_duration_min: number;
  require_member_present: boolean;
  keep_secondary_source: boolean;
  video_layout: string;
  mode_restrictions: OrgSettingsOutModeRestrictions;
  screen_share_content: string;
  listing_defaults: OrgSettingsOutListingDefaults;
  sharing_ceiling: string;
  scheduler_default_access: boolean;
  other_bot_policy: string;
  interviewer_metrics_exposure: string;
  language: string;
  code_switch_set: string[];
  vocabulary: string[];
  recipient_policy: string;
  notification_defaults: OrgSettingsOutNotificationDefaults;
  attach_recap_pdf: boolean;
  attach_transcript_pdf: boolean;
  scorecard_auto_generate: boolean;
  artifact_language: string | null;
  regen_per_artifact_per_hour: number;
  limits: OrgSettingsOutLimits;
  updated_at: string;
}
